<template>
  <section>
    <div class="home_wrap">
      <el-row class="desc_row">
        <div class="desc_bg_wrap">
          <img src="/static/images/logo.png" alt="" class="logoPic" @click="handleHome">
          <ul class="navUl">
            <li class="active">产品首页</li>
            <li @click="handlePurchase">产品购买</li>
            <!-- <li @click="handleNews">付费资讯</li> -->
            <li @click="handleLinkUs">联系我们</li>
            <li @click="handleLogin">登录入口</li>
          </ul>
          <h1 class="navUl_h1 animate__animated animate__fadeInUp delay-0-1s">瑞森安全生产管理平台</h1>
          <h4 class="navUl_h4  animate__animated animate__fadeInUp delay-0-4s">运筹帷幄中，安全管控行</h4>
          <div class="nav_btn">
            <span @click="handlePurchase" class="animate__animated animate__fadeInUp delay-0-7s">立即购买</span>
            <span @click="handleLogin" class="animate__animated animate__fadeInUp delay-0-10s">登录入口</span>
          </div>
          <div class="desc_content animate__animated animate__fadeInUp delay-0-25s">
            <h4>平台简介</h4>
            <p>瑞森安全生产管理平台是服务企业安全生产标准化管理的平台，应用互联网+计算技术，为企业搭建安全生产标准化管理的一体化SaaS服务平台。平台以国家《安全生产法》、《突发事件应对法》为根本依据，结合各级行政法规、规章、规范化文件以及标准规范等文件要求，开发设计出涵盖企业日常安全生产闭环管理的流程系统。其中，包含风险分级管控和隐患排查治理、教育培训计划管理、现场管理、应急管理、制度管理等模块。全面帮助企业落实安全生产主体责任，通过系统分级吸纳各层级人员有序参与安全生产全过程管理，建立安全生产管理标准化体系，并持续改进。最终形成生产经营活动的安全管理标准化、标准成果信息化、目标职责措施化、理念措施任务化、任务执行常态化、执行记录数据化、数据存储证据化的智慧安全生产管理体系。</p>
          </div>
        </div>
      </el-row>
      <!-- 平台功能 -->
      <el-row class="fun_row" id="fun_row">
        <h1 :class="{'animate__animated animate__fadeInUp delay-0-1s':fun_row_flag}">平台功能</h1>
        <el-row class="fun_wrap">
          <img  :class="{'animate__animated animate__fadeInUp delay-0-5s':fun_row_flag}" src="/static/images/funPic.png" alt="">
          <div class="fun_item1" :class="{'animate__animated animate__fadeInUp delay-0-9s':fun_row_flag}">
            <h4>安全管控</h4>
            <p>以风险为核心，坚持超前防范、关口前移，从风险辨识入手，以风险管控、隐患排查治理为手段，解决“认不清、想不到”的问题，建立风险分级管控和隐患排查治理双重预防性工作机制。</p>
          </div>
          <div class="fun_item2" :class="{'animate__animated animate__fadeInUp delay-0-13s':fun_row_flag}">
            <h4>统计分析</h4>
            <p>提供领导驾驶舱分析仪表盘页面、隐患排查治理统计报表等报表功能，可全景或局部地展现企业安全生产管理业务运行情况，同时支持按时间、部门、关键字等条件筛选和数据检索。</p>
          </div>
          <div class="fun_item3" :class="{'animate__animated animate__fadeInUp delay-0-17s':fun_row_flag}">
            <h4>数字签名</h4>
            <p>平台采用绑定国家认证的CA机构颁发的数字证书，植入身份核验+电子签名技术，使数据存储符合国家《电子签名法》，满足企业提供符合行政监管要求的规范化法律效力文件的需求。</p>
          </div>
          <div class="fun_item4" :class="{'animate__animated animate__fadeInUp delay-0-20s':fun_row_flag}">
            <h4>导入导出</h4>
            <p>支持风险管控信息台账等大表单数据模板导出编辑，并批量导入表单数据。系统内生成的执行历史记录数据支持PDF格式文件导出，可按需、及时、准确、完整地导出企业所需的数据文本和表单文件。</p>
          </div>
          <div class="fun_item5" :class="{'animate__animated animate__fadeInUp delay-0-24s':fun_row_flag}">
            <h4>智能提醒</h4>
            <p>将隐患排查治理、设备检测维护、证件复审换证、培训计划执行、临时工作计划等工作内容任务化，并下发至相关责任人终端提醒执行，并给出待办、完成、逾期等多种状态提醒和倒计时时间提醒。</p>
          </div>
        </el-row>
      </el-row>
      <!-- 平台优势 -->
      <el-row class="advantage" id="advantage">
        <h1 :class="{'animate__animated animate__fadeInUp delay-0-1s':advantage_flag}">平台优势</h1>
        <div class="advan_wrap">
          <div class="advan_item" :class="{'animate__animated animate__fadeInUp delay-0-5s':advantage_flag}">
            <img src="/static/images/advan1.png" alt="">
            <h4>依法依规</h4>
            <p>遵循法律、法规、规章、规范性文件、标准规范等条文逐条拆解，深入落实到系统各个模块、各个业务流程当中，让平台成为法律法规的细致解说员和专业咨询师。</p>
          </div>
          <div class="advan_item" :class="{'animate__animated animate__fadeInUp delay-0-7s':advantage_flag}">
            <img src="/static/images/advan2.png" alt="">
            <h4>高效便捷</h4>
            <p>通过4G/5G技术和计算技术的融合，实现SaaS平台和移动智能终端的无缝衔接，实现责任人快捷、便利性执行，一键参与安全生产管理，并将数据在全企业成员内实现随时随地的实时同步。</p>
          </div>
          <div class="advan_item" :class="{'animate__animated animate__fadeInUp delay-0-9s':advantage_flag}">
            <img src="/static/images/advan3.png" alt="">
            <h4>数据融合</h4>
            <p>将企业散落的文件等非结构化数据信息化，形成线下数据线上迁移，破解企业数据的遗失、错漏等痛点，打破企业传统的数据孤岛，整合安全生产管理数据并驱动数据价值，促进数据融合。</p>
          </div>
          <div class="advan_item" :class="{'animate__animated animate__fadeInUp delay-0-11s':advantage_flag}">
            <img src="/static/images/advan4.png" alt="">
            <h4>决策支持</h4>
            <p>平台整体各模块的逻辑衔接、流程梳理及各类报表分析，有效地培养企业各级安全生产管理人员的时间管理、绩效管理、成本管理理念，促进企业管理人员决策再思考并向高效规范化管理挖掘效益。</p>
          </div>
          <div class="advan_item" :class="{'animate__animated animate__fadeInUp delay-0-13s':advantage_flag}">
            <img src="/static/images/advan5.png" alt="">
            <h4>人工智能</h4>
            <p>平台通过持续升级迭代，采用大数据+机器学习技术，分类梳理出公共知识库、行业知识库、企业知识库、特殊知识库，未来向企业用户定制化输出，提升企业整体的增效降本体验。</p>
          </div>
        </div>
      </el-row>
      <!-- 合作伙伴 -->
      <el-row class="partner_row" id="partner_row">
        <h1 :class="{'animate__animated animate__fadeInUp delay-0-3s':partner_row_flag}">合作伙伴</h1>
        <ul>
          <li>
            <img :class="{'animate__animated animate__fadeInUp delay-0-6s':partner_row_flag}" src="/static/images/partner1.png" alt="">
          </li>
          <li>
            <img :class="{'animate__animated animate__fadeInUp delay-0-9s':partner_row_flag}" src="/static/images/partner2.png" alt="">
          </li>
        </ul>
      </el-row>
    </div>
    <Footer></Footer>
  </section>
</template>
<script>
import Footer from '../components/common/footer'
export default {
  name: 'home',
  components: { Footer },
  data () {
    return {
      fun_row_top:0,
      fun_row_flag:false,
      advantage_top:0,
      advantage_flag:false,
      partner_row_top:0,
      partner_row_flag:false,
    }
  },
  mounted(){
    let that=this;
    window.addEventListener('scroll',this.handleScroll)
    that.$nextTick(() => {
     setTimeout(() => {
        let targetbox= document.getElementById('fun_row').offsetTop-300;
        that.fun_row_top=targetbox
        let targetbox1= document.getElementById('advantage').offsetTop-300;
        that.advantage_top=targetbox1
        let targetbox2= document.getElementById('partner_row').offsetTop;
        that.partner_row_top=targetbox2
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener("scroll",this.handleScroll)
  },
  created(){
  },
  methods:{
    handleScroll(){
      let that=this;
      var scrollTop=window.pageXOffset||document.documentElement.scrollTop||document.body.scrollTop
      if(scrollTop>=that.fun_row_top){
        that.fun_row_flag=true
      }else if(scrollTop>=that.advantage_top){
        that.advantage_flag=true
        that.fun_row_flag=false
      }else if(scrollTop>=that.partner_row_top){
        that.advantage_flag=true
        that.advantage_flag=false
        that.fun_row_flag=false
      }
    },
    handleLogin(){//登录管理后台
      window.location.href=this.oUrl.API_HOST
    },
    handlePurchase(){//登录管理后台
      this.$router.push({path: '/purchasePage'});
    },
    handleLinkUs(){
      this.$router.push({path: '/contactUs'});
    },
    // handleNews(){
    //   this.$router.push({path: '/counselPaid'});
    // },
    handleHome(){
      this.$router.push({path: '/'});
    },
  }
}
</script>
<style lang="less" scoped>
body{
  h4,h1{
    padding: 0;
    margin: 0;
  }
}
body{font-size: 12px}
.home_wrap{
  min-width: 1024px;
  background: #F8F9FC;
  .desc_row{
    width: 100%;
    height: 14.43rem;
    .desc_bg_wrap{
      width: 100%;
      height: 10.65rem;
      background: url('/static/images/banner.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;
      .logoPic{
        width: 2.34rem;
        // height: 0.7rem;
        position: absolute;
        top: 0.48rem;
        left: 1.77rem;
        color: #ffffff;
        cursor: pointer;
      }
      .navUl_h1{
        font-size: 0.64rem;
        line-height: 0.9rem;
        position: absolute;
        top: 3.74rem;
        left: 1.74rem;
        color: #ffffff;
      }
      .navUl_h4{
        font-size: 0.22rem;
        line-height: 0.44rem;
        position: absolute;
        top: 4.94rem;
        left: 1.74rem;
        color: #ffffff;
      }
      .nav_btn{
        position: absolute;
        top: 6.74rem;
        left: 1.74rem;
        color: #ffffff;
        span{
          width:2.67rem;
          height:0.8rem;
          color: #ffffff;
          text-align: center;
          line-height: 0.8rem;
          font-weight: 600;
          display: inline-block;
          background:rgba(69,102,245,1);
          box-shadow:0 -0.11rem 0.45rem 0 rgba(69,102,245,0.4);
          border-radius:0 0.13rem 0 0.13rem;
          margin-right: 0.9rem;;
          font-size: 0.32rem;
          font-weight: 600;
          cursor: pointer;
        }
        span:hover{
          background:rgba(69,102,245,0.6);
          color: rgba(255,255,255,0.9);
        }
        span:last-child{
          margin-left: 0;
        }
      }
      .navUl{
        position: absolute;
        top: 0.48rem;
        right: 1.77rem;
        list-style: none;
        li{
          line-height: 0.46rem;
          font-size: 0.22rem;
          margin-right: 0.52rem;
          color: #ffffff;
          float: left;
          cursor: pointer;
        }
        li:last-child{
          margin-right: 0;
        }
        li:hover,li.active{
          color: #4566F5;
        }
      }
      .desc_content{
        width: 87%;
        position: absolute;
        top: 9.9rem;
        left: 50%;
        margin-left: -43.5%;
        background:rgba(255,255,255,1);
        box-shadow:16px 16px 53px 0 rgba(210,210,210,0.5);
        border-radius:0.13rem;
        text-align: left;
        padding-bottom: 0.64rem;
        h4{
          color: #031D5B;
          font-size: 0.42rem;
          line-height: 0.6rem;
          margin: 0.64rem 0 0.36rem 1.06rem;
        }
        p{
          text-indent: 2em;
          font-size: 0.24rem;
          line-height: 0.48rem;
          color: #5B6C94;
          margin: 0 0.56rem;
        }
      }
    }
  }
  .fun_row{
    width: 100%;
    padding: 1.3rem 0 0;
    height: 14rem;
    h1{
      font-size: 0.42rem;
      margin: 0;
      padding: 0;
      color: #031D5B;
      line-height: 0.6rem;
    }
    .fun_wrap{
      width: 100%;
      height: 12.08rem;
      position: relative;
      img{
        width: 6.65rem;
        height: 6.26rem;
        position: absolute;
        top: 3rem;
        left: 50%;
        margin-left: -3.325rem;
      }
      .fun_item1{
        width: 7.02rem;
        position: absolute;
        top: 1.14rem;
        left: 50%;
        margin-left: -3.51rem;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: center;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item2{
        width: 4.8rem;
        position: absolute;
        top: 5.4rem;
        right: 10%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: left;
          text-indent: 2em;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item3{
        width: 4.86rem;
        position: absolute;
        top: 8.6rem;
        right: 12%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: left;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item4{
        width: 4.86rem;
        position: absolute;
        top: 8.6rem;
        left: 12%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: right;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item5{
        width: 4.9rem;
        position: absolute;
        top: 5.4rem;
        left: 6.5%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: right;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
    }
  }
  // 平台优势
  .advantage{
    width: 100%;
    padding: 1.3rem 0;
    h1{
      font-size: 0.78rem;
      margin: 0;
      padding: 0;
      font-size: 0.42rem;
      line-height: 0.78rem;
      font-weight: 600;
      margin-bottom: 0.57rem;
    }
    .advan_wrap{
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      vertical-align: middle;
      .advan_item{
        text-align: left;
        display: inline-block;
        height: 5.03rem;
        width: 19%;
        padding: 0.26rem;
        cursor: pointer;
        vertical-align: middle;
        margin-right: 0.22rem;
        background:linear-gradient(180deg,rgba(235,243,255,1) 0%,rgba(255,255,255,1) 100%);
        img{
          width: 0.72rem;
        }
        h4{
          margin: 0;
          padding: 0;
          margin: 0.2rem 0;
          color: #031D5B;
          font-size: 0.28rem;
          line-height: 0.4rem;
        }
        p{
          text-indent: 2em;
          color: #5B6C94;
          font-size: 0.22rem;
          line-height: 0.4rem;
        }
      }
      .advan_item:last-child{
        margin-right: 0;
      }
    }
  }
  .partner_row{
    width: 100%;
    padding: 0 0 1.3rem 0;
    h1{
      font-size: 0.42rem;;
      line-height: 0.6rem;;
      color: #031D5B;
      margin: 0;
      padding: 0;
      margin-bottom: 0.58rem;;
    }
    ul{
      width: 90%;
      height: auto;
      margin: 0 auto;
      list-style: none;
      text-align: center;
      li{
        width: 3.45rem;
        height: 1.70rem;
        display: inline-block;
        margin: 0 0.3rem 0;
        vertical-align: middle;
        background:rgba(255,255,255,1);
        box-shadow:0.16rem 0.16rem 0.53rem 0 rgba(210,210,210,0.5);
        margin-right: 0.42rem;
        img{
          width: 100%;
        }
      }
      li:last-child{
        margin-right: 0;
      }
    }
  }
}
@media screen and(min-width: 1280px) {
  .home_wrap{
    .fun_wrap{
      position: relative;
      img{
        width: 6.65rem;
        height: 6.26rem;
        position: absolute;
        top: 285px;
        left: 50%;
        margin-left: -3.325rem;
      }
      .fun_item1{
        width: 7.02rem;
        position: absolute;
        top: 1.14rem;
        left: 50%;
        margin-left: -3.51rem;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: center;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item2{
        width: 4.8rem;
        position: absolute;
        top: 5.4rem;
        right: 3rem;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: left;
          text-indent: 2em;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item3{
        width: 4.86rem;
        position: absolute;
        top: 8.4rem;
        right: 22%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: left;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item4{
        width: 4.86rem;
        position: absolute;
        top: 8.6rem;
        left: 22%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: right;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
      .fun_item5{
        width: 4.9rem;
        position: absolute;
        top: 5.4rem;
        left: 18%;
        h4{
          color: #031D5B;
          font-size: 0.36rem;
          line-height: 0.5rem;
          text-align: right;
          margin-bottom: 0.12rem;
        }
        p{
          font-size: 0.22rem;
          line-height: 0.36rem;
          color: #5B6C94;
          text-align: left;
          text-indent: 2em;
        }
      }
    }
  }
}
@media screen and(min-width: 1680px) {
  .home_wrap{
    .desc_row{
      width: 100%;
      height: 1443px;
      .desc_bg_wrap{
        width: 100%;
        height: 1065px;
        background: url('/static/images/banner.png');
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        .logoPic{
          width: 234px;
          // height: 70px;
          position: absolute;
          top: 48px;
          left: 177px;
          color: #ffffff;
          cursor: pointer;
        }
        .navUl_h1{
          font-size: 64px;
          line-height: 90px;
          position: absolute;
          top: 374px;
          left: 174px;
          color: #ffffff;
        }
        .navUl_h4{
          font-size: 22px;
          line-height: 44px;
          position: absolute;
          top: 494px;
          left: 174px;
          color: #ffffff;
        }
        .nav_btn{
          position: absolute;
          top: 674px;
          left: 174px;
          color: #ffffff;
          span{
            width:267px;
            height:80px;
            color: #ffffff;
            text-align: center;
            line-height: 80px;
            font-weight: 600;
            display: inline-block;
            background:rgba(69,102,245,1);
            box-shadow:0px -11px 45px 0px rgba(69,102,245,0.4);
            border-radius:0px 13px 0px 13px;
            margin-right: 90px;
            font-size: 32px;
            font-weight: 600;
            cursor: pointer;
          }
          span:last-child{
            margin-left: 0;
          }
        }
        .navUl{
          position: absolute;
          top: 48px;
          right: 188px;
          list-style: none;
          li{
            line-height: 46px;
            font-size: 22px;
            margin-right: 52px;
            color: #ffffff;
            float: left;
            cursor: pointer;
          }
          li:last-child{
            margin-right: 0;
          }
        }
        .desc_content{
          width: 87%;
          position: absolute;
          top: 990px;
          left: 50%;
          margin-left: -43.5%;
          background:rgba(255,255,255,1);
          box-shadow:0px 13px 45px 0px rgba(210,210,210,0.5);
          border-radius:13px;
          text-align: left;
          padding-bottom: 64px;
          h4{
            color: #031D5B;
            font-size: 42px;
            line-height: 60px;
            margin: 64px 0 36px 106px;
          }
          p{
            text-indent: 2em;
            font-size: 24px;
            line-height: 48px;
            color: #5B6C94;
            margin: 0 56px;
          }
        }
      }
    }
    .fun_row{
      width: 100%;
      padding: 130px 0 0;
      height: 1400px;
      margin-top: 30px;
      h1{
        font-size: 42px;
        margin: 0;
        padding: 0;
        color: #031D5B;
        line-height: 60px;
      }
      .fun_wrap{
        width: 100%;
        height: 1208px;
        position: relative;
        img{
          width:665px;
          height: 626px;
          position: absolute;
          top: 285px;
          left: 50%;
          margin-left: -332.5px;
        }
        .fun_item1{
          width: 702px;
          position: absolute;
          top: 8%;
          left: 50%;
          margin-left: -351px;
          h4{
            color: #031D5B;
            font-size: 36px;
            line-height: 50px;
            text-align: center;
            margin-bottom: 12px;
          }
          p{
            font-size: 22px;
            line-height: 36px;
            color: #5B6C94;
            text-align: left;
            text-indent: 2em;
          }
        }
        .fun_item2{
          width: 456px;
          position: absolute;
          top: 520px;
          right: 200px;
          h4{
            color: #031D5B;
            font-size: 36px;
            line-height: 50px;
            text-align: left;
            text-indent: 2em;
            margin-bottom: 12px;
          }
          p{
            font-size: 22px;
            line-height: 36px;
            color: #5B6C94;
            text-align: left;
            text-indent: 2em;
          }
        }
        .fun_item3{
          width: 486px;
          position: absolute;
          top: 840px;
          right: 220px;
          h4{
            color: #031D5B;
            font-size: 36px;
            line-height: 50px;
            text-align: left;
            margin-bottom: 12px;
          }
          p{
            font-size: 22px;
            line-height: 36px;
            color: #5B6C94;
            text-align: left;
            text-indent: 2em;
          }
        }
        .fun_item4{
          width: 486px;
          position: absolute;
          top: 830px;
          left: 230px;
          h4{
            color: #031D5B;
            font-size: 36px;
            line-height: 50px;
            text-align: right;
            margin-bottom: 12px;
          }
          p{
            font-size: 22px;
            line-height: 36px;
            color: #5B6C94;
            text-align: left;
            text-indent: 2em;
          }
        }
        .fun_item5{
          width: 480px;
          position: absolute;
          top: 530px;
          left: 180px;
          h4{
            color: #031D5B;
            font-size: 36px;
            line-height: 50px;
            text-align: right;
            margin-bottom: 12px;
            padding-right: 1.8em;
          }
          p{
            font-size: 22px;
            line-height: 36px;
            color: #5B6C94;
            text-align: left;
            text-indent: 2em;
          }
        }
      }
    }
    // 平台优势
    .advantage{
      width: 100%;
      padding: 0 0 130px 0;
      h1{
        font-size: 78px;
        margin: 0;
        padding: 0;
        font-size: 42px;
        line-height: 78px;
        margin-bottom: 57px;
      }
      .advan_wrap{
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .advan_item{
          height: 503px;
          text-align: left;
          width: 19%;
          padding: 22px 24px;
          cursor: pointer;
          background:linear-gradient(180deg,rgba(235,243,255,1) 0%,rgba(255,255,255,1) 100%);
          img{
            width: 72px;
          }
          h4{
            margin: 0;
            padding: 0;
            margin: 20px 0;
            color: #031D5B;
            font-size: 28px;
            line-height: 40px;
          }
          p{
            text-indent: 2em;
            color: #5B6C94;
            font-size: 22px;
            line-height: 40px;
          }
        }
      }
    }
    .partner_row{
      width: 100%;
      padding: 130px 0;
      h1{
        font-size: 42px;
        line-height: 60px;
        color: #031D5B;
        margin: 0;
        padding: 0;
        margin-bottom: 58px;
      }
      ul{
        width: 90%;
        height: auto;
        margin: 0 auto;
        list-style: none;
        text-align: center;
        li{
          width: 345px;
          height: 170px;
          display: inline-block;
          margin: 0 30px 0;
          vertical-align: middle;
          background:rgba(255,255,255,1);
          // box-shadow: rgba(210,210,210,0.95) 0px 0px 16px;
          box-shadow:16px 16px 53px 0px rgba(210,210,210,0.5);
          margin-right: 42px;
          img{
            width: 100%;
          }
        }
        li:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue